import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminA.vue?vue&type=template&id=404adc22&scoped=true"
import script from "./ExtendOtherNutrientsVitaminA.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminA.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminA.vue?vue&type=style&index=0&id=404adc22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404adc22",
  null
  
)

export default component.exports